<script>
import {
  DISEASE_LABELS,
  getDiseaseLabels,
  getDiseaseSpecies,
  getPetIcon,
} from "./diseaseUtils";
import SFormGroup from "../SFormGroup.vue";

export default {
  name: "s-zlifepet-info-doenca",
  components: { SFormGroup },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    disease: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],

  data() {
    return {
      diseaseLabels: DISEASE_LABELS,
    };
  },

  computed: {
    labels() {
      return getDiseaseLabels(this.disease.labels);
    },
    species() {
      return getDiseaseSpecies(this.disease.species);
    },
    definition() {
      return this.disease.definition.split("\n");
    },
    diagnosis() {
      return this.disease.diagnosis.split("\n");
    },
    prevention() {
      return this.disease.prevention.split("\n");
    },
    references() {
      return this.disease.references?.split("\n");
    },
    symptoms() {
      return this.disease.symptoms.split("\n");
    },
    transmission() {
      return this.disease.transmission?.split("\n");
    },
    treatment() {
      return this.disease.treatment.split("\n");
    },
  },

  methods: {
    getPetIcon,
  },
};
</script>

<template>
  <s-janela bt-mi :visible="visible"
    :title="`Informações sobre ${disease.name}`" :width="800" :height="700"
    @close="$emit('close')">
    <s-layout class="disease-info-body">
      <div class="s-card disease-info">
        <h3 style="margin-bottom: 12px">{{disease.name}}</h3>
        <div class="disease-info-tags disease-info-tags__labels">
          <div
            :class='`tag ${String(state) === "true" ? "danger" : "secondary"}`'
            v-if="labels" v-for="([label, state]) in labels">
            {{ diseaseLabels[label][state] }}
          </div>
        </div>
        <s-form-group :model-value="true" header='Espécies afetadas'>
          <div class="disease-info-tags disease-info-tags__species">
            <div class="tag" v-for="sp in species" :key="sp">
              <i :class="`mdi ${getPetIcon(sp)}`">{{sp}}</i>
            </div>
          </div>
        </s-form-group>
        <s-form-group :model-value="true" header='Definição'>
          <p v-for="line in definition">{{ line }}</p>
        </s-form-group>
        <s-form-group :model-value="true" header='Diagnóstico'>
          <ul>
            <template v-for="line in diagnosis">
              <li v-if='line.startsWith("-")'>
                {{ line.replace("-", "").trim() }}
              </li>
              <p v-else>{{ line }}</p>
            </template>
          </ul>
        </s-form-group>
        <s-form-group :model-value="true" header='Prevenção'>
          <p v-for="line in prevention">{{ line }}</p>
        </s-form-group>
        <s-form-group :model-value="true" header='Sintomas'>
          <ul>
            <template v-for="line in symptoms">
              <li v-if='line.startsWith("-")'>{{ line.replace("-", "") }}</li>
              <p v-else>{{ line }}</p>
            </template>
          </ul>
        </s-form-group>
        <s-form-group v-if="transmission" :model-value="true"
          header='Transmissão'>
          <ul>
            <template v-for="line in transmission">
              <li v-if='line.startsWith("-")'>{{ line.replace("-", "") }}</li>
              <p v-else>{{ line }}</p>
            </template>
          </ul>
        </s-form-group>
        <s-form-group :model-value="true" header='Tratamento'>
          <p v-for="line in treatment">{{ line }}</p>
        </s-form-group>
        <s-form-group v-if="references" :model-value="true"
          header='Referências'>
          <p v-for="line in references">{{ line }}</p>
        </s-form-group>
      </div>

      <template v-slot:footer>
        <button type="button" @click="$emit('close')">Fechar</button>
      </template>
    </s-layout>
  </s-janela>
</template>

<style scoped>
.tag {
  color: #085d75;
  background-color: #cfe9f1;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid currentColor;
}

.tag.secondary {
  color: #345e68;
  background-color: #ebeff0;
}

.tag.danger {
  color: #991b1b;
  background-color: #fee2e2;
}

.disease-info {
  font-size: 14px;
}

.disease-info-tags {
  gap: 4px;
  display: flex;
  flex-wrap: wrap;
}

.disease-info-tags__species .tag {
  font-weight: 500;
}

.disease-info-tags__species i::before {
  font-size: 1.125em;
  margin-right: 4px;
}

.disease-info-tags__labels {
  margin-top: auto;
}

.disease-info-tags__labels .tag {
  height: fit-content;
}

.disease-info-tags__labels .tag.danger {
  font-weight: 500;
}

:deep(.s-form-group-container) {
  padding: 1em;
}

p {
  margin-bottom: 1em;
}
</style>